var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('intro'),_vm._v(" "),_c('what'),_vm._v(" "),_c('limit'),_vm._v(" "),_c('news'),_vm._v(" "),_c('how'),_vm._v(" "),_c('why'),_vm._v(" "),_c('who'),_vm._v(" "),_c('sfs'),_vm._v(" "),_c('outro')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }